import { useRouter } from 'next/router';
import styles from './forgot-password.module.scss';
import ForgotPasswordForm from './forgot-password-form';

export type ForgotPasswordProps = {
  emailRequired: string;
  emailInvalid: string;
};

const ForgotPassword = ({ emailRequired, emailInvalid }: ForgotPasswordProps) => {
  const router = useRouter();

  //reset password token expired
  const { expired } = router.query;

  return (
    <div className={styles.container}>
      <ForgotPasswordForm errorMessages={{ emailRequired, emailInvalid }} expired={expired} />
    </div>
  );
};

export default ForgotPassword;
